import React, {useRef, useState} from 'react';

import {ScrollView, View, StyleSheet} from 'react-native';

import TopSection from './TopSection';
import Summary from './Summary';
import Learning from './Learning';
import QuickWatch from './QuickWatch';
import KeyPoints from './KeyPoints';
import ReflectiveQuestions from './ReflectiveQuestions';
import FurtherReading from './FurtherReading';
import Quiz from './Quiz';
import UsefulLinks from './UsefulLinks';
import Acknowledgment from './Acknowledgment';
import UpTicks from './UpTicks';
import AMImageViewer from '../AMImageViewer';

import {PSIRF_TYPES} from '../../constants/psirf';
import PSIRFController from '../../classes/PSIRFController';

const getComponent = (index, section, screenProps, psirfMetaData) => {
  switch (section.type) {
    case PSIRF_TYPES.TOP_SECTION:
      return (
        <TopSection
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.SUMMARY:
      return (
        <Summary
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.LEARNING:
      return (
        <Learning
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
          displayLength={psirfMetaData.learningDisplayLength}
        />
      );
    case PSIRF_TYPES.EXTENDED_LEARNING:
      return (
        <Learning
          key={index}
          content={section.content.Content}
          psirfMetaData={psirfMetaData}
          displayLength={section.content.DisplayLength}
          getImageSrc={fileName =>
            PSIRFController.getImagePath(fileName, section.content.ID)
          }
        />
      );
    case PSIRF_TYPES.QUICK_WATCH:
      return (
        <QuickWatch
          key={index}
          content={section.content}
          updateVideoHistory={screenProps.updateVideoHistory}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.KEY_POINTS:
      return (
        <KeyPoints
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.REFLECTIVE_QUESTIONS:
      return (
        <ReflectiveQuestions
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.FURTHER_READING:
      return (
        <FurtherReading
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.QUIZ: {
      const quizLink = section?.content.QuizLink;
      return (
        <Quiz
          key={index}
          content={section.content}
          onPress={() => screenProps.openPsirfQuiz(quizLink)}
          psirfMetaData={psirfMetaData}
        />
      );
    }
    case PSIRF_TYPES.USEFUL_LINKS:
      return (
        <UsefulLinks
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
        />
      );
    case PSIRF_TYPES.ACKNOWLEDGMENT:
      return (
        <Acknowledgment
          key={index}
          user={screenProps.user}
          title={psirfMetaData.title}
          contentId={psirfMetaData.psirfId}
          type="psirf"
          color="white"
        />
      );
    case PSIRF_TYPES.UP_TICKS:
      return (
        <UpTicks
          key={index}
          content={section.content}
          psirfMetaData={psirfMetaData}
          user={screenProps.user}
        />
      );
    default:
      return null;
  }
};

const PSIRFRenderer = ({data, screenProps}) => {
  const [imageModalPath, setImageModalPath] = useState(null);

  const handleImageModal = imagePath => {
    setImageModalPath(imagePath);
  };

  const handleCloseImageModal = () => {
    setImageModalPath(null);
  };
  const topSection = data.content.find(
    section => section.type === 'TopSection',
  );
  const title = topSection.content.topSectionTitle;
  const date = topSection.content.DisplayDate;
  const scrollViewRef = useRef(null);
  const psirfMetaData = {
    title,
    date,
    psirfId: data.ID,
    displayType: data.DisplayType,
    learningDisplayLength: data.LearningDisplayLength,
    imageOnPressHandler: handleImageModal,
  };
  const components = data.content.map((item, index) =>
    getComponent(index, item, screenProps, psirfMetaData),
  );
  return (
    <>
      <ScrollView ref={scrollViewRef}>
        <View style={styles.container}>{components}</View>
      </ScrollView>
      <AMImageViewer
        visible={imageModalPath !== null}
        imageUrls={[{url: imageModalPath, props: {}}]}
        onClose={handleCloseImageModal}
      />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    marginHorizontal: 'auto',
  },
});

export default PSIRFRenderer;
